import React, { useEffect, useState, useRef } from 'react';
import {useNavigate, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import RegisterUserService from '../../services/RegisterUserService';

const lbl = {
  display: 'block', fontSize: '12px', fontWeight: '600',
  color: '#8392ab', marginBottom: '6px',
  textTransform: 'uppercase', letterSpacing: '0.05em',
};
const inp = (err, disabled) => ({
  width: '100%', padding: '10px 14px',
  border: `1.5px solid ${err ? '#f5365c' : disabled ? '#f0f2f5' : '#e9ecef'}`,
  borderRadius: '10px', fontSize: '14px',
  color: disabled ? '#adb5bd' : '#344767',
  background: disabled ? '#f8f9fe' : '#fff',
  outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s',
  cursor: disabled ? 'not-allowed' : 'text',
});
const errMsg = { fontSize: '11px', color: '#f5365c', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' };

const SecHead = ({ color, icon, title, note }) => (
  <div style={{ paddingBottom: '10px', borderBottom: '1.5px solid #f0f2f5', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
    <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', color, fontSize: '13px' }}>
      <i className={`fas ${icon}`} />
    </div>
    <p style={{ fontSize: '13px', fontWeight: '700', color: '#344767', textTransform: 'uppercase', letterSpacing: '0.06em', margin: 0 }}>{title}</p>
    {note && <span style={{ fontSize: '11px', color: '#adb5bd', fontWeight: '500', textTransform: 'none', letterSpacing: 0, marginLeft: '4px' }}>{note}</span>}
  </div>
);

const ReadField = ({ label, value }) => (
  <div className="col-md-4">
    <label style={lbl}>{label}</label>
    <input type="text" disabled readOnly style={inp(false, true)} value={value || '—'} />
  </div>
);

const EditField = ({ label, name, type = 'text', placeholder, value, error, onChange }) => (
  <div className="col-md-4">
    <label style={lbl} htmlFor={name}>{label}</label>
    <input
      type={type} id={name} name={name}
      className="eu-input"
      style={inp(!!error, false)}
      value={value || ''} onChange={onChange}
      placeholder={placeholder || label}
    />
    {error && <p style={errMsg}><i className="fas fa-exclamation-circle" />{error}</p>}
  </div>
);

function EditUser() {
  const { id } = useParams();
  const toast = useRef(null);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    streetAddress: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    panNumber: "",
    panImage: null,
    passportNumber: "",
    aadharNumber:"",
    isActive: false,
    id: id,
    clientId:""
  });
  const [formError, setFormError] = useState({});
  
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const fetchUserData = async () => {
      try {
        const user = await RegisterUserService.getUserById(id);
        if (!cancelled) {
          setForm(prev => ({ ...prev, ...user, id }));
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };

    fetchUserData();
    return () => { cancelled = true; };
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === 'checkbox') {
      setForm(prevForm => ({ ...prevForm, [name]: checked }));
    } else if (files) {
      setForm(prevForm => ({ ...prevForm, [name]: files[0] }));
    } else {
      setForm(prevForm => ({ ...prevForm, [name]: value }));
    }
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(form).forEach(key => {
      const value = String(form[key]);
      if (!value.trim() && key !== 'panImage') {
        errors[key] = `Please enter ${key}`;
      }
    });
    setFormError(errors);
    return Object.keys(errors).length === 0;
  };

  const updateUser = async () => {
    const isValid = validateForm();
    if (!isValid) return;
    
    const formDataToSend = new FormData();
    
    Object.keys(form).forEach(key => {
      if (key === 'panImage' && form[key] instanceof File) {
        formDataToSend.append(key, form[key]);
      } else {
        formDataToSend.append(key, form[key]);
      }
    });
  
    try {
      await RegisterUserService.updateUser(id, formDataToSend);
      if (toast.current) {
        toast.current.show({
          severity: 'success',
          summary: 'Success',
          detail: 'User updated successfully',
          className: 'custom-toast-success',
          life: 3000
        });
      }

      setTimeout(() => {
        // navigate("/registeruser");
        navigate(-1);
      }, 800);
    } catch (error) {
      console.error("Error updating User:", error);
      if (toast.current) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update user',
          className: 'custom-toast-delete',
          life: 3000
        });

      }
    }
  };
  
  const initials = [form.firstName, form.lastName]
    .filter(Boolean).map(n => n[0].toUpperCase()).join('') || '?';

  return (
    <div style={{ padding: '24px', minHeight: '100vh', background: '#f4f6fb' }}>
      <Toast ref={toast} />
      <style>{`
        .eu-input:focus { border-color: #344767 !important; box-shadow: 0 0 0 3px rgba(52,71,103,0.1) !important; }
        .eu-submit:hover { opacity: 0.88; transform: translateY(-1px); }
        .eu-ghost:hover { background: #f0f2f5 !important; }
        .eu-toggle { position: relative; display: inline-block; width: 46px; height: 26px; }
        .eu-toggle input { opacity: 0; width: 0; height: 0; }
        .eu-slider { position: absolute; cursor: pointer; inset: 0; background: #e9ecef; border-radius: 26px; transition: 0.3s; }
        .eu-slider:before { position: absolute; content: ''; height: 18px; width: 18px; left: 4px; bottom: 4px; background: white; border-radius: 50%; transition: 0.3s; box-shadow: 0 1px 4px rgba(0,0,0,0.2); }
        input:checked + .eu-slider { background: linear-gradient(135deg,#2dce89,#26af74); }
        input:checked + .eu-slider:before { transform: translateX(20px); }
      `}</style>

      {/* Page Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '12px',
            background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: '20px', boxShadow: '0 4px 12px rgba(52,71,103,0.3)',
          }}>
            <i className="fas fa-user-edit" />
          </div>
          <div>
            <p style={{ fontSize: '22px', fontWeight: '700', color: '#344767', margin: 0, lineHeight: 1.2 }}>Edit Employee</p>
            <p style={{ fontSize: '13px', color: '#8392ab', margin: 0, marginTop: '2px' }}>User ID #{id}</p>
          </div>
        </div>
        <button
          type="button"
          className="eu-ghost"
          onClick={() => navigate(-1)}
          style={{
            background: '#fff', border: '1.5px solid #e9ecef', borderRadius: '10px',
            padding: '9px 20px', fontSize: '13px', fontWeight: '600', color: '#525f7f',
            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '7px', transition: 'all 0.2s',
          }}
        >
          <i className="fas fa-arrow-left" />Back
        </button>
      </div>

      {/* User Identity Banner */}
      {form.firstName && (
        <div style={{
          background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
          borderRadius: '16px', padding: '20px 24px', marginBottom: '24px',
          display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap',
          boxShadow: '0 4px 20px rgba(52,71,103,0.2)',
        }}>
          <div style={{
            width: '56px', height: '56px', borderRadius: '50%', flexShrink: 0,
            background: 'rgba(255,255,255,0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: '20px', fontWeight: '700',
            border: '2px solid rgba(255,255,255,0.3)',
          }}>
            {initials}
          </div>
          <div style={{ flex: 1, minWidth: '180px' }}>
            <p style={{ color: '#fff', fontWeight: '700', fontSize: '17px', margin: 0 }}>
              {form.firstName} {form.lastName}
            </p>
            <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '13px', margin: 0, marginTop: '2px' }}>
              {form.email || 'No email'}&nbsp;·&nbsp;{form.contactNumber || 'No contact'}
            </p>
          </div>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
            <span style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', borderRadius: '20px', padding: '5px 16px', fontSize: '12px', fontWeight: '600' }}>
              <i className="fas fa-map-marker-alt" style={{ marginRight: '6px' }} />
              {[form.city, form.state].filter(Boolean).join(', ') || 'No location'}
            </span>
            <span style={{
              background: form.isActive ? 'rgba(45,206,137,0.25)' : 'rgba(245,54,92,0.25)',
              color: '#fff', borderRadius: '20px', padding: '5px 16px',
              fontSize: '12px', fontWeight: '700',
              border: `1px solid ${form.isActive ? 'rgba(45,206,137,0.4)' : 'rgba(245,54,92,0.4)'}`,
            }}>
              <i className={`fas ${form.isActive ? 'fa-check-circle' : 'fa-times-circle'}`} style={{ marginRight: '6px' }} />
              {form.isActive ? 'Active' : 'Inactive'}
            </span>
          </div>
        </div>
      )}

      <form onSubmit={e => e.preventDefault()}>
        <div style={{ background: '#fff', borderRadius: '20px', boxShadow: '0 4px 24px rgba(52,71,103,0.08)', overflow: 'hidden' }}>

          {/* Gradient strip */}
          <div style={{
            background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
            padding: '20px 28px', display: 'flex', alignItems: 'center', gap: '10px',
          }}>
            <i className="fas fa-id-badge" style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px' }} />
            <span style={{ color: '#fff', fontWeight: '600', fontSize: '15px' }}>Employee Profile</span>
          </div>

          <div style={{ padding: '32px 28px' }}>

            {/* Section 1 – Personal (read-only) */}
            <div style={{ marginBottom: '28px' }}>
              <SecHead color="#8392ab" icon="fa-lock" title="Personal Details" note="(read-only)" />
              <div className="row g-3">
                <ReadField label="First Name" value={form.firstName} />
                <ReadField label="Last Name" value={form.lastName} />
                <ReadField label="Email Address" value={form.email} />
              </div>
            </div>

            {/* Section 2 – Security */}
            <div style={{ marginBottom: '28px' }}>
              <SecHead color="#5e72e4" icon="fa-shield-alt" title="Security" />
              <div className="row g-3">
                <EditField label="New Password" name="password" type="password" placeholder="Leave blank to keep current" value={form.password} error={formError.password} onChange={handleInputChange} />
                <EditField label="Contact Number" name="contactNumber" placeholder="+91 XXXXX XXXXX" value={form.contactNumber} error={formError.contactNumber} onChange={handleInputChange} />
              </div>
            </div>

            {/* Section 3 – Location */}
            <div style={{ marginBottom: '28px' }}>
              <SecHead color="#fb6340" icon="fa-map-marker-alt" title="Location" />
              <div className="row g-3">
                <EditField label="Street Address" name="streetAddress" value={form.streetAddress} error={formError.streetAddress} onChange={handleInputChange} />
                <EditField label="City" name="city" value={form.city} error={formError.city} onChange={handleInputChange} />
                <EditField label="State" name="state" value={form.state} error={formError.state} onChange={handleInputChange} />
                <EditField label="Country" name="country" value={form.country} error={formError.country} onChange={handleInputChange} />
                <EditField label="Postal Code" name="postalCode" type="number" value={form.postalCode} error={formError.postalCode} onChange={handleInputChange} />
              </div>
            </div>

            {/* Section 4 – Identity */}
            <div style={{ marginBottom: '28px' }}>
              <SecHead color="#11cdef" icon="fa-id-card" title="Identity Documents" />
              <div className="row g-3">
                <ReadField label="PAN Number" value={form.panNumber} />
                <ReadField label="Passport Number" value={form.passportNumber} />
                <EditField label="Aadhar Number" name="aadharNumber" value={form.aadharNumber} error={formError.aadharNumber} onChange={handleInputChange} />
              </div>
            </div>

            {/* Section 5 – Account */}
            <div>
              <SecHead color="#2dce89" icon="fa-cog" title="Account Settings" />
              <div className="row g-3">
                <div className="col-md-4">
                  <label style={lbl} htmlFor="panImage">PAN Card Image</label>
                  <input
                    type="file" id="panImage" name="panImage"
                    className="eu-input form-control"
                    style={{ ...inp(false, false), padding: '7px 14px', cursor: 'pointer' }}
                    onChange={handleInputChange} accept="image/*"
                  />
                  {formError.panImage && <p style={errMsg}><i className="fas fa-exclamation-circle" />{formError.panImage}</p>}
                </div>

                <div className="col-md-4">
                  <label style={lbl}>Account Status</label>
                  <div style={{
                    display: 'flex', alignItems: 'center', gap: '14px',
                    padding: '10px 14px',
                    border: '1.5px solid #e9ecef', borderRadius: '10px',
                    background: '#fff',
                  }}>
                    <label className="eu-toggle" htmlFor="isActive">
                      <input
                        type="checkbox" id="isActive" name="isActive"
                        checked={form.isActive} onChange={handleInputChange}
                      />
                      <span className="eu-slider" />
                    </label>
                    <span style={{
                      fontSize: '14px', fontWeight: '600',
                      color: form.isActive ? '#2dce89' : '#8392ab',
                    }}>
                      {form.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div style={{
            padding: '20px 28px', background: '#f8f9fe',
            borderTop: '1.5px solid #f0f2f5',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px',
          }}>
            <span style={{ fontSize: '13px', color: '#8392ab', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="fas fa-lock" style={{ color: '#8392ab', fontSize: '11px' }} />
              Greyed fields are system-locked and cannot be changed
            </span>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                type="button"
                className="eu-ghost"
                onClick={() => navigate(-1)}
                style={{
                  background: 'transparent', border: '1.5px solid #e9ecef',
                  borderRadius: '10px', padding: '10px 24px',
                  fontSize: '14px', fontWeight: '600', color: '#8392ab',
                  cursor: 'pointer', transition: 'all 0.2s',
                }}
              >
                <i className="fas fa-times" style={{ marginRight: '7px' }} />Cancel
              </button>
              <button
                type="button"
                className="eu-submit"
                onClick={updateUser}
                style={{
                  background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
                  border: 'none', borderRadius: '10px', padding: '10px 32px',
                  fontSize: '14px', fontWeight: '700', color: '#fff',
                  cursor: 'pointer', boxShadow: '0 4px 15px rgba(52,71,103,0.3)',
                  display: 'flex', alignItems: 'center', gap: '8px', transition: 'all 0.2s',
                }}
              >
                <i className="fas fa-save" />Save Changes
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditUser;
